import { render, staticRenderFns } from "./AbilityLayout.vue?vue&type=template&id=4ff1379c&scoped=true&"
import script from "./AbilityLayout.vue?vue&type=script&lang=js&"
export * from "./AbilityLayout.vue?vue&type=script&lang=js&"
import style0 from "./AbilityLayout.vue?vue&type=style&index=0&id=4ff1379c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1379c",
  null
  
)

export default component.exports